import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { CancellationReason } from './cancellation-reason';
import { Driver } from './driver';
import { OrganizationPaymentMethod } from './organization-payment-method';
import { ProviderFeeScheduleDetail } from './provider-fee-schedule-detail';
import { ReservationStatus } from './reservation-status';
import { RiderProtectedRideRequestDetail } from './rider-protected-ride-request-detail';
import { Vehicle } from './vehicle';
import { AbstractModel } from './abstract-model';
import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';

@inheritSerialization(AbstractModel)
export class RiderProtectedReservationDetail extends AbstractModel {
  @autoserializeAs(Driver)
  driver: Driver;

  @autoserializeAs(RiderProtectedRideRequestDetail)
  protectedRideRequestDetail: RiderProtectedRideRequestDetail;

  @autoserializeAs(Vehicle)
  vehicle: Vehicle;

  @autoserializeAs(Date)
  completedDate: Date;

  @autoserialize
  cancelled: boolean;

  @autoserializeAs(CancellationReason)
  cancellationReason: CancellationReason;

  @autoserializeAs(Date)
  cancelledDate: Date;

  @autoserializeAs(ReservationStatus)
  reservationStatus: ReservationStatus;

  @autoserializeAs(Date)
  pickUpArrivedDate: Date;

  @autoserializeAs(Date)
  inProgressDate: Date;

  @autoserialize
  riderSignatureCaptureEnabled: boolean;

  @autoserializeAs(OrganizationPaymentMethod)
  supportedPaymentMethods: Array<OrganizationPaymentMethod>;

  @autoserialize
  driverIdBadgeRequired: boolean;

  @autoserialize
  vehicleInspectionRequired: boolean;

  @autoserializeAs(ProviderFeeScheduleDetail)
  providerFeeScheduleDetail: ProviderFeeScheduleDetail;

  get displayDate(): Date {
    if (!isNullOrUndefined(this.protectedRideRequestDetail.pickupDate)) {
      return this.protectedRideRequestDetail.pickupDate;
    } else if (!isNullOrUndefined(this.inProgressDate)) {
      return this.inProgressDate;
    } else if (this.cancelled) {
      return this.cancelledDate;
    }
    return this.modifiedDate;
  }

  static OnSerialized(reservationList: RiderProtectedReservationDetail, json: any): void {
    super.OnSerialized(reservationList, json);

    if (!isNullOrUndefined(reservationList.completedDate)) {
      json.completedDate = DateUtil.serializeDate(reservationList.completedDate);
    }

    if (!isNullOrUndefined(reservationList.cancelledDate)) {
      json.cancelledDate = DateUtil.serializeDate(reservationList.cancelledDate);
    }

    if (!isNullOrUndefined(reservationList.pickUpArrivedDate)) {
      json.pickUpArrivedDate = DateUtil.serializeDate(reservationList.pickUpArrivedDate);
    }

    if (!isNullOrUndefined(reservationList.inProgressDate)) {
      json.inProgressDate = DateUtil.serializeDate(reservationList.inProgressDate);
    }
  }

  static OnDeserialized(instance: RiderProtectedReservationDetail, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeDate(json['completedDate']);
    }

    if (!isNullOrUndefined(json['cancelledDate'])) {
      instance.cancelledDate = DateUtil.deserializeDate(json['cancelledDate']);
    }

    if (!isNullOrUndefined(json['pickUpArrivedDate'])) {
      instance.pickUpArrivedDate = DateUtil.deserializeDate(json['pickUpArrivedDate']);
    }

    if (!isNullOrUndefined(json['inProgressDate'])) {
      instance.inProgressDate = DateUtil.deserializeDate(json['inProgressDate']);
    }
  }
}
